import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { withContent } from '@bubbletea/core';
import { pollWindowVariable } from '@mooncake/mooncake-gateway-core/utils';
import Button from '../index';
import { ActionsContainer } from './styles';
import goToSection from '../../../../utils/goToSection';
import { IStoreState } from '../../../../types/store';
import { IContent } from '../../../../types';
import { IIbexPricingDetail } from '../../../../types/subscription';
// import isRestricted from '../../../../utils/isRestricted';
// import { setAgeRestricted } from '../../../../features/appSlice';
import Loader from '../../../../core/UI/Loader';
import { IAdobeClickEvent } from '../../../../types/tracking';
import sendEvent from '../../../../utils/sendEvent';
import { IMainTheme } from '../../../../types/theme';

interface ISubscriptionButtonsProps {
  context: IContent;
  onlyPlayNow?: boolean;
  tracking?: IAdobeClickEvent;
}

type TIbexPricingDetails = {
  subscriptions: IIbexPricingDetail[];
};

const SubscriptionButtons = ({ context, onlyPlayNow = false, tracking }: ISubscriptionButtonsProps) => {
  const theme = useTheme() as IMainTheme;
  // const dispatch = useDispatch();
  const [ibexPricingDetails, setIbexPricingDetails] = useState<TIbexPricingDetails>({ subscriptions: [] });
  const contentSelector = useSelector((state: IStoreState) => ({
    // ageRestricted: state.app.ageRestricted,
    subscriptions: state.user.user.subscriptions,
    userLoading: state.user.loading,
  }));
  const { userLoading, subscriptions } = contentSelector;
  const { global } = context.googlesheet;

  const subscriptionActive = subscriptions.some((subscription) => subscription.status === 'active');
  const subscriptionInactive = subscriptions.some((subscription) => subscription.status === 'inactive');

  const isUPC = window.location.pathname.indexOf('/upc/') > -1;

  useEffect(() => {
    pollWindowVariable<TIbexPricingDetails>('window.ibexPricingDetails')
      .then((ibex) => {
        setIbexPricingDetails(ibex);
      })
      .catch((error) => {
        console.error('poll IbexPricingDetails error: ', error);
      });

    // const listenToAgeGate = () => {
    //   if (window.jQuery) {
    //     // @ts-ignore
    //     $(document).on('ageGateConfirm', async () => {
    //       const isButtonRestricted = await isRestricted();
    //       dispatch(setAgeRestricted(isButtonRestricted));
    //     });
    //   } else {
    //     setTimeout(() => {
    //       listenToAgeGate();
    //     }, 50);
    //   }
    // };
    //
    // listenToAgeGate();
    //
    // return () => {
    //   if (window.jQuery) {
    //     // @ts-ignore
    //     $(document).off('ageGateConfirm', async () => {
    //       const isButtonRestricted = await isRestricted();
    //       dispatch(setAgeRestricted(isButtonRestricted));
    //     });
    //   }
    // };
  }, [ibexPricingDetails]);

  let isFreeTrial = false;
  if (ibexPricingDetails.subscriptions.length) {
    isFreeTrial = ibexPricingDetails.subscriptions.some((subscription) =>
      subscription.promotions?.some((promotion) => promotion.type === 'freeTrial')
    );
  }

  const openUbiConnectModal = useCallback(() => {
    const eventDetails = {
      location: tracking?.location as string,
      category: 'interaction',
      locationPosition: tracking?.locationPosition as number,
      action: 'rocksmith plus : play now',
    };
    sendEvent(eventDetails);
    if (isUPC) {
      window.location.href = 'uplay://open/game/5763';
    } else {
      const openSubModalEvent = new CustomEvent('OPEN_UBICONNECT_MODAL');
      document.dispatchEvent(openSubModalEvent);
    }
  }, []);

  const openManageSub = useCallback(() => {
    const eventDetails = {
      location: tracking?.location as string,
      category: 'action',
      locationPosition: tracking?.locationPosition as number,
      action: 'manage subscription',
    };
    sendEvent(eventDetails);
    if (isUPC) {
      window.location.href = '/upc/ca/subscription-hub';
    } else {
      window.location.href = '/my-account#account-ubisoftplus';
    }
  }, []);

  const goToPlans = (type?: string) => {
    const eventDetails = {
      location: tracking?.location as string,
      locationDetail: type === 'reactivate' ? 'reactivate rocksmith plus' : 'subscribe to rocksmith plus',
      category: tracking?.location === 'hero banner' ? 'action' : tracking?.category || 'interaction',
      locationPosition: tracking?.locationPosition as number,
      action: type === 'reactivate' ? 'rocksmith plus : reactivate' : 'rocksmith plus : subscribe',
    };
    goToSection('plans');
    sendEvent(eventDetails);
  };

  // const tooltipAgeGateEventDetails = {
  //   location: 'age gate',
  //   locationDetail: "age gate : sorry you can't access this content",
  //   category: 'display',
  //   locationPosition: 'tooltip',
  //   action: 'visible',
  // };

  return userLoading ? (
    <Loader
      over={false}
      backgroundColor={'transparent'}
      color={tracking?.location === 'hero banner' ? theme.colors['White'] : theme.colors['Black']}
    />
  ) : subscriptions.length ? (
    <ActionsContainer>
      {subscriptionActive ? (
        <Button type="buy" handleClick={() => openUbiConnectModal()}>
          {global.playNow}
        </Button>
      ) : subscriptionInactive ? (
        <Button type="buy" handleClick={() => goToPlans('reactivate')}>
          {global.reactivate}
        </Button>
      ) : null}
      {!subscriptionInactive && !onlyPlayNow ? (
        <Button type="outlined" classNames={['outlined']} handleClick={() => openManageSub()}>
          {global.manageSubscription}
        </Button>
      ) : null}
    </ActionsContainer>
  ) : (
    <Button
      handleClick={() => goToPlans()}
      classNames={['hero-subscribe-cta']}
      key="subscribe-cta"
      type="buy"
      // disabled={ageRestricted}
      // tooltipContent={ageRestricted && `${global.ageGate}<br>${global.privacyPolicy}`}
      // tooltipTracking={tooltipAgeGateEventDetails}
      // tooltipTrackingType={'impressionevent'}
    >
      {isFreeTrial ? global.tryForFree : global.subscribeNow}
    </Button>
  );
};

export default withContent(SubscriptionButtons);
